import { Layout } from "../Layout";
import { Seo } from "../../seo/Seo";
import { Reveal } from "../Reveal";

export default function PrivacyPolicy() {
  return (
    <Layout>
      <Seo path="/privacy-policy" />
      <section className="page-hero" data-testid="privacy-page-hero">
        <div className="wrap">
          <Reveal>
            <h1 className="page-title" data-testid="privacy-page-title">Privacy Policy</h1>
          </Reveal>
        </div>
      </section>
      <section className="section legal-section" data-testid="privacy-content">
        <div className="wrap">
          <div className="legal-content">
            <p className="legal-updated">Last updated: 4 October 2026</p>

            <h2>Who we are</h2>
            <p>
              KR Studio is a creative, branding, marketing and AI studio founded by Roohi Maryam and Kafeel
              Rabbani. Our registered address is 4697/6 - 21A Ansari Road, Daryaganj, Central Delhi, 110002,
              India, and our website is www.thekrstudio.com. This policy explains what personal information we
              collect, how we use it, and the choices you have.
            </p>

            <h2>Information we collect</h2>
            <p>We collect the following kinds of information:</p>
            <ul>
              <li>
                <strong>Details you submit</strong> through our contact and project enquiry forms — your name,
                email address, phone number, company, message and budget.
              </li>
              <li>
                <strong>Messages you send us</strong> on WhatsApp, email, Instagram or LinkedIn.
              </li>
              <li>
                <strong>Technical data collected automatically</strong> — your IP address, browser and device
                type, the pages you visit and the referring URL — through cookies and similar technologies.
              </li>
            </ul>

            <h2>Cookies and tracking</h2>
            <p>
              We use cookies and the Meta Pixel (by Meta Platforms, Inc.), and may use analytics tools, to
              measure website traffic, understand how visitors use the site, and show and measure ads on
              Facebook and Instagram. Meta may use this data in line with its own policy, available at{" "}
              <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer">
                facebook.com/privacy/policy
              </a>
              . You can control cookies through your browser settings and manage your ad preferences at{" "}
              <a href="https://www.facebook.com/adpreferences" target="_blank" rel="noopener noreferrer">
                facebook.com/adpreferences
              </a>
              .
            </p>

            <h2>How we use information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>respond to your enquiries;</li>
              <li>prepare proposals and deliver our services;</li>
              <li>communicate with you about projects;</li>
              <li>improve our website; and</li>
              <li>run and measure our marketing and advertising.</li>
            </ul>

            <h2>Sharing your information</h2>
            <p>
              We do not sell personal data. We share it only with service providers who help us operate — such
              as hosting, email, analytics and advertising platforms like Meta — when required by law, or with
              your consent.
            </p>

            <h2>Data retention</h2>
            <p>
              We keep personal information only as long as needed for the purposes described above, or as
              required by law.
            </p>

            <h2>Security</h2>
            <p>
              We use reasonable technical and organisational measures to protect your information. However, no
              method of transmission or storage is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2>Your rights</h2>
            <p>
              You can access, correct, update or delete your personal data, and withdraw your consent, in line
              with India's Digital Personal Data Protection Act, 2023 and other applicable laws.
            </p>

            <h2>Data deletion requests</h2>
            <p>
              To request deletion of your data, email{" "}
              <a href="mailto:admin@thekrstudio.com">admin@thekrstudio.com</a> with the subject{" "}
              <strong>"Data Deletion Request"</strong>. We will process your request within 30 days.
            </p>

            <h2>Children</h2>
            <p>
              Our services are not directed to children under 18, and we do not knowingly collect their
              personal data.
            </p>

            <h2>Third-party links</h2>
            <p>
              Our website may link to other sites. We are not responsible for the privacy practices of those
              sites.
            </p>

            <h2>Changes to this policy</h2>
            <p>
              We may update this policy from time to time. When we do, we will post the updated version on
              this page with a new "Last updated" date.
            </p>

            <h2>Contact / Grievance</h2>
            <p>
              For any questions, concerns or grievances about this policy or your personal data, contact us at{" "}
              <a href="mailto:admin@thekrstudio.com">admin@thekrstudio.com</a>, call{" "}
              <a href="tel:+917006676788">+91 70066 76788</a>, or write to KR Studio, 4697/6 - 21A Ansari Road,
              Daryaganj, Central Delhi, 110002, India.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
